
<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable width="600px">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" small><v-icon left>mdi-plus</v-icon>Usuário</v-btn>
      </template>
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Novo usuário</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog()" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-form ref="createForm">
            <v-text-field label="Nome" v-model="new_user.name" :rules="required"></v-text-field>
            <v-text-field label="Email" v-model="new_user.email" :rules="emailRules"></v-text-field>
            <v-select label="Tipo de usuário" item-value="value" item-text="text" :items="user_kind_options" v-model="new_user.kind" :rules="required"></v-select>
            <v-text-field label="Departamento" v-model="department_name" v-if="department_name"></v-text-field>
            <select-department :create_user="true" @saveDepartment="handleSaveDepartment"></select-department>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="success" @click="newUser()"><v-icon left>mdi-check</v-icon>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'CreateUserDialog',
  components: {
    SelectDepartment: () => import('@/components/_execution/create/shared/NewExecutionDepartment.vue'),
  },
  mixins: [
    validations 
  ],
  data() {
    return {
      dialog: false,
      new_user: {
        name: '',
        email: '',
        password: '',
        kind: null,
        department_ids: []
      },
      user_kind_options: [
        { text: 'Admin', value: 'admin' },
        { text: 'Comum', value: 'execute' }
      ],
      department_name: null
    }
  },
  methods: {
    clearNewUser() {
      this.new_user = {
        name: '',
        email: '',
        password: '',
        kind: null,
        department_ids: []
      }
    },
    async newUser() {
      if (this.$refs.createForm.validate() && this.new_user.department_ids.length) {
        this.loading = true;
        await this.createUser(this.new_user)
        this.clearNewUser();
        this.loading = false;
        this.dialog = false;
      }
    },
    handleSaveDepartment(department) {
      this.new_user.department_ids[0] = department.id;
      this.department_name = department.name;
      console.log(this.new_user)
    },
    closeDialog() {
      this.clearNewUser();
      this.dialog = false;
    },
    ...mapActions({
      createUser: 'User/create'
    })
  },
  computed: {
    ...mapState({

    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>